import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useModelMeshStore } from '../state/store'

const usePositionHighlighting = (highlightedPositions: string[], stateId?: string) => {
  const addHighlightedPositions = useModelMeshStore(state => state.addHighlightedPositions)
  const removeHighlightedPositions = useModelMeshStore(state => state.removeHighlightedPositions)

  useLayoutEffect(() => {
    const uuid = stateId || v4()

    if (highlightedPositions.length) {
      addHighlightedPositions(uuid, highlightedPositions)
    }

    return () => removeHighlightedPositions(uuid)
  }, [addHighlightedPositions, highlightedPositions, removeHighlightedPositions, stateId])
}

export default usePositionHighlighting
